import {
  ArrowLeft,
  ChefHat,
  Clock3,
  Database,
  Sparkles,
  UsersRound,
} from "lucide-react";
import { delayEvidenceEpisodes } from "../data/delayEvidence";
import type { DelayAlert } from "../types";

export function DelayHistoryPanel({
  alert,
  onClose,
}: {
  alert: DelayAlert;
  onClose: () => void;
}) {
  return (
    <div className="delay-history-view">
      <button className="delay-history-back" type="button" onClick={onClose}>
        <ArrowLeft size={17} aria-hidden="true" />
        Back to live kitchen
      </button>

      <header className="delay-history-heading">
        <span>
          <Database size={14} aria-hidden="true" />
          VECTOR EVIDENCE
        </span>
        <h1>{alert.evidenceCount} similar shifts</h1>
        <p>
          Past situations used to predict <strong>{alert.predictedReadyInMinutes} min</strong> for{" "}
          {alert.itemLabel}.
        </p>
      </header>

      <div className="delay-history-metrics" aria-label="Evidence summary">
        <span><b>{Math.round(alert.similarity * 100)}%</b> best match</span>
        <span><b>+{alert.predictedDelayMinutes}m</b> predicted delay</span>
        <span><b>{alert.evidenceCount}</b> outcomes compared</span>
      </div>

      <div className="delay-episode-list">
        {delayEvidenceEpisodes.slice(0, alert.evidenceCount).map((episode, index) => (
          <article key={episode.id}>
            <div className="delay-episode-topline">
              <span>#{String(index + 1).padStart(2, "0")} · {episode.date} · {episode.time}</span>
              <strong>{Math.round(episode.similarity * 100)}% match</strong>
            </div>
            <div className="delay-episode-title">
              <h2>{episode.primaryDish}</h2>
              <span>{episode.durationMinutes} min <b>+{episode.delayMinutes}</b></span>
            </div>
            <p>{episode.condition}</p>
            <dl>
              <div>
                <dt><ChefHat size={13} /> Concurrent</dt>
                <dd>{episode.concurrentDishes.join(", ")}</dd>
              </div>
              <div>
                <dt><UsersRound size={13} /> Workforce</dt>
                <dd>{episode.workforce}</dd>
              </div>
              <div>
                <dt><Sparkles size={13} /> Response</dt>
                <dd>{episode.response}</dd>
              </div>
              <div>
                <dt><Clock3 size={13} /> Outcome</dt>
                <dd>{episode.outcome}</dd>
              </div>
            </dl>
          </article>
        ))}
      </div>
    </div>
  );
}
